import styled from 'styled-components'

export const ButtonStyled = styled.button`
  cursor: pointer;
  width: 20px;
  height: 20px;
  color: ${({ textColor }) => textColor};
  background-color: ${({ bgColor }) => bgColor};
  font-size: 12px;
`
